<div class="row opacity transistion h-52 ml-0 mr-0" [routerLink]="['/customer', customer.customerId?.slice(0, 36)]">
    <div class="col-auto pr-0 pt-2"> 
      <app-customerlogo
        [customerId]="customer.customerId"
        [customerlistmode]="true"
        [enableChange]="false">
      </app-customerlogo>
    </div>
    <div class="col-5"> 
      <h6
        appHighlight
        [searchedWord]="filterTxt"
        [classToApply]="'font-weight-bold'"
        [setTitle]="'true'"
        [content]="customer.title"
        class="align-middle mb-0 my-auto lh-52 pl-2 cursor-pointer text-truncate">
      </h6>
    </div>
    <div class="col-2 d-none d-sm-block">
      <p class="align-middle mb-0 my-auto lh-52 cursor-pointer">
        {{ customer.main_contact }}
      </p>
    </div>
    <div *ngIf="hubspotintegration" class="col-2 d-none d-sm-block">
      <p class="align-middle mb-0 my-auto lh-52 cursor-pointer">
        {{ 'customercontrol.deals' | trans }}{{ customer.numberofdeals }}
      </p>
    </div>
  </div>
  
